import { PageLayoutDefaultErrorPageGeneral } from "@sis/react-library";
import { ErrorPageProps } from './ErrorPageProps';

interface ErrorPageGeneralProps {
    forTests?: boolean;
}

export const ErrorPageGeneral = ({forTests}: ErrorPageGeneralProps) => {
    return (
        <PageLayoutDefaultErrorPageGeneral
            {...ErrorPageProps()} forTests={forTests}
        />
    )
}
